import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function ItemsToProcessList({ shipmentItems, quantityStrategy, singleQuantity, shipment }) {
  const isOnsiteInventory = shipment?.shipmentStatus === 'onsite_inventory';
  
  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        Items ({shipmentItems.length})
      </Typography>
      <Box
        maxHeight={150}
        overflowY="auto"
        border="1px solid"
        borderColor="divider"
        borderRadius={1}
      >
        {shipmentItems.map((item, index) => {
          let quantity;
          let quantityLabel;
          
          if (quantityStrategy === "single") {
            quantity = singleQuantity;
            quantityLabel = isOnsiteInventory ? "Expected Quantity" : "Origin Quantity";
          } else if (quantityStrategy === "expected") {
            quantity = item.expectedQuantity;
            quantityLabel = "Expected Quantity";
          } else {
            quantity = item.asset?.quantity;
            quantityLabel = "Origin Quantity";
          }

          return (
            <Box
              key={item.id || index}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={1}
              borderBottom={index < shipmentItems.length - 1 ? "1px solid" : "none"}
              borderColor="divider"
            >
              <Typography variant="body2" noWrap title={item.asset?.description} sx={{ flex: 1 }}>
                {item.asset?.itemId || "Unknown Item"}
                {item.asset?.description && `, ${item.asset.description}`}
              </Typography>
              <Typography variant="body2" sx={{ ml: 2, whiteSpace: "nowrap" }}>
                {quantityLabel}: {quantity || "—"}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
